export default __webpack_public_path__ + "static/media/dhl_aviation@3x.3559cb7e.png";